<template>
  <ProductPageLayout
    name="GifMaker"
    :logo="logo"
    :hero-image="heroImage"
    lead="Convert locally — nothing is uploaded. Import video, record your screen, and finish in one editor: trim the timeline, control file size, and turn moments into GIFs."
    :feature-lines="featureLines"
    download-link="/ftp/packages/gifmaker/GifMakerSetup.exe"
    download-file-name="GifMakerSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="From import to export — editor and toolbox cover the full GIF workflow."
    other-desc="Compress, reverse, multi-image compose, and format convert in one place."
    reviews-desc="Real feedback that keeps shaping the GifMaker experience."
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'GifMaker',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/gifmaker/logo_48x48.png'),
      heroImage: require('@/assets/gifmaker/首页.png'),
      featureLines: [
        'Video to GIF / screen record / timeline trim / quality presets',
        'GIF compress / reverse / multi-image compose / format convert / history'
      ],
      metaItems: [
        { icon: 'video', label: 'Video to GIF' },
        { icon: 'lock', label: 'Local only' },
        { icon: 'ad-free', label: 'No watermark by default' }
      ],
      detailedFeatures: [
        {
          title: 'Video to GIF',
          brief: 'Import mp4 / mov / mkv and more, trim on the timeline, export in one click.',
          detail: 'Batch import and convert. Precisely pick clips, preview frames, and use three quality presets to balance size and clarity.',
          image: require('@/assets/gifmaker/编辑台.png')
        },
        {
          title: 'Screen recording',
          brief: 'Capture a region or the full screen with hotkeys, then jump straight into the editor.',
          detail: 'Great for tutorials, demos, and social clips. After recording, trim and export a GIF without opening another app.',
          image: require('@/assets/gifmaker/屏幕录制.png')
        },
        {
          title: 'GIF toolbox',
          brief: 'Compress, reverse, multi-image compose, and format convert in one toolkit.',
          detail: 'Built-in compress, reverse, frame edit, image-sequence compose, plus GIF / WebP / APNG conversion — no tool-hopping.',
          image: require('@/assets/gifmaker/工具.png')
        },
        {
          title: 'History',
          brief: 'Recent converts and recordings are archived so you can reopen and re-export anytime.',
          detail: 'Keeps the last 100 convert, record, and toolbox jobs. Jump to source paths, re-edit, or share exported GIFs.',
          image: require('@/assets/gifmaker/历史.png')
        }
      ],
      otherFeatures: [
        { title: 'GIF compress', description: 'Shrink file size with acceptable quality for chat and docs.', icon: 'image' },
        { title: 'Frame edit', description: 'Delete or reorder frames in an existing GIF, then export again.', icon: 'puzzle' },
        { title: 'Multi-image compose', description: 'Build a GIF from an image sequence — stickers and simple animation.', icon: 'sparkle' },
        { title: 'Local processing', description: 'Convert and record on your PC. Default exports have no watermark.', icon: 'lock' }
      ],
      reviews: [
        { name: 'Alex', comment: 'I trim product demos into GIFs for the team chat — timeline editing is smooth and files are much smaller.', avatar: require('@/assets/gifmaker/avatar1.jpg') },
        { name: 'Sam', comment: 'UI motion exports finally live in one app. Compress and reverse in the toolbox saved me a lot of time.', avatar: require('@/assets/gifmaker/avatar2.jpg') },
        { name: 'Jordan', comment: 'Record a bug repro, convert to GIF, paste into the ticket. Hotkeys feel solid.', avatar: require('@/assets/gifmaker/avatar3.jpg') },
        { name: 'Taylor', comment: 'Batch short clips to GIF with quality presets. History makes finding old exports easy.', avatar: require('@/assets/gifmaker/avatar4.jpeg') },
        { name: 'Casey', comment: 'I record lesson steps as GIFs — clearer for students than static screenshots.', avatar: require('@/assets/gifmaker/avatar5.jpeg') },
        { name: 'Riley', comment: 'Multi-image stickers are quick, and local-only processing is reassuring.', avatar: require('@/assets/gifmaker/avatar6.jpeg') }
      ]
    }
  }
}
</script>
